import { render, staticRenderFns } from "./DrawingBoard.vue?vue&type=template&id=049fe19c&scoped=true&"
import script from "./DrawingBoard.vue?vue&type=script&lang=js&"
export * from "./DrawingBoard.vue?vue&type=script&lang=js&"
import style0 from "./DrawingBoard.vue?vue&type=style&index=0&id=049fe19c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049fe19c",
  null
  
)

export default component.exports